import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabase';
import './BranchSelector.css';

function BranchSelector({ schoolId, selectedBranchId, onBranchChange }) {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!schoolId) {
      setBranches([]);
      setLoading(false);
      return;
    }

    const fetchBranches = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('branches')
          .select('*')
          .eq('school_id', schoolId)
          .eq('is_active', true)
          .order('branch_name');

        if (error) {
          console.error('Error fetching branches:', error);
          setBranches([]);
        } else {
          setBranches(data || []);
        }
      } catch (err) {
        console.error('Exception fetching branches:', err);
        setBranches([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, [schoolId]);

  const handleChange = (e) => {
    const branchId = e.target.value === 'all' ? null : parseInt(e.target.value);
    onBranchChange(branchId);
  };

  if (loading) {
    return (
      <div className="branch-selector">
        <span className="branch-selector-label">Loading branches...</span>
      </div>
    );
  }

  if (branches.length === 0) {
    return null; // Don't show selector if no branches
  }

  return (
    <div className="branch-selector">
      <label htmlFor="branch-select" className="branch-selector-label">
        Branch:
      </label>
      <select
        id="branch-select"
        className="branch-select"
        value={selectedBranchId || 'all'}
        onChange={handleChange}
      >
        <option value="all">All Branches</option>
        {branches.map((branch) => (
          <option key={branch.id} value={branch.id}>
            {branch.branch_name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default BranchSelector;
